import {createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'PROFILES/BILL_PAYER/PROFILE_V2';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(`${domain}/FETCH`, (institutionId: string, billPayerId: string) => ({institutionId, billPayerId}));

export const {
    action: fetchRecurringPayments,
    success: fetchRecurringPaymentsSuccess,
    failed: fetchRecurringPaymentsFailed,
} = createAction(`${domain}/FETCH_RECURRING_PAYMENTS`, (institutionId: string, billPayerId: string) => ({
    institutionId,
    billPayerId,
}));
